import { createSvg } from '../createSvg';

const Wallet = (
    {
        strokeWidth = 1.5,
    },
): JSX.Element => {
    return <g id={'contour'}>
        <path
            d='M22 12V17C22 20 20 22 17 22H7C4 22 2 20 2 17V12C2 9.28 3.64 7.38 6.19 7.06C6.45 7.02 6.72 7 7 7H17C17.26 7 17.51 7.00999 17.75 7.04999C20.33 7.34999 22 9.26 22 12Z'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M17.7514 7.05C17.5114 7.01 17.2614 7.00001 17.0014 7.00001H7.00141C6.72141 7.00001 6.45141 7.02001 6.19141 7.06001C6.33141 6.78001 6.53141 6.52001 6.77141
            6.28001L10.0214 3.02C11.3914 1.66 13.6114 1.66 14.9814 3.02L16.7314 4.79002C17.3714 5.42002 17.7114 6.22 17.7514 7.05Z'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
        <path
            d='M22 12.5H19C17.9 12.5 17 13.4 17 14.5C17 15.6 17.9 16.5 19 16.5H22'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </g>;
};

export default createSvg(
    Wallet,
    'wallet',
);
